class EventEmitter {
  private listeners: any = {};

  on(eventName: string, listener: any): void {
    if (this.listeners[eventName]) {
      this.listeners[eventName].push(listener);
    } else {
      this.listeners[eventName] = [listener];
    }
  }

  off(eventName: string, listener: any): void {
    const listeners = this.listeners[eventName];
    if (listeners) {
      this.listeners[eventName] = this.listeners[eventName]
        .filter((item: any) => item !== listener);
    }
  }

  emit(eventName: string, data: any): void {
    const listeners = this.listeners[eventName];

    if (listeners) {
      listeners.forEach((item: any) => item(data));
    }
  }
}

export default new EventEmitter();
